import { appParams } from "@/lib/app-params";
import { createClient } from "@base44/sdk";

const { appId, token, functionsVersion, appBaseUrl } = appParams;

export const base44 = createClient({
  appId,
  token,
  functionsVersion,
  serverUrl: "",
  appBaseUrl,
});
